import { dispatchAmplitudeEvent } from 'src/utils/amplitude'

type QuickViewEventName =
  | 'Quick View Opened'
  | 'Quick View Clicked'
  | 'Quick View Added to Cart'
  | 'Quick View Closed'

type QuickViewEventInput = {
  standardObject: Record<string, unknown> | null
  productObject: Record<string, unknown> | null
  extraData?: Record<string, unknown>
}

export const buildQuickViewEventData = ({
  standardObject,
  productObject,
  extraData,
}: QuickViewEventInput) => {
  return {
    ...(standardObject ?? {}),
    ...(extraData ?? {}),
    'product details': productObject ? [productObject] : [],
  }
}

export const dispatchQuickViewEvent = (
  eventName: QuickViewEventName,
  input: QuickViewEventInput
) => {
  if (!input.standardObject || !input.productObject) {
    return
  }

  dispatchAmplitudeEvent({
    eventName,
    eventData: buildQuickViewEventData(input),
  })
}
